import PropTypes from "prop-types"
import React from "react"
import styled from 'styled-components'

const Head = styled.header`
  display: flex;
  justify-content: center;
  padding: 2rem;

  img {
    max-width: 400px;
    width: 100%;
  }
`

const Header = ({ siteTitle }) => (
  <Head>
  <img src="https://s3.amazonaws.com/underwoods/logo.png" alt="underwood jewlers logo" />
  </Head>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
